import React from 'react';
import { Link } from 'react-router-dom';
import CourseStep from './CourseStep';
import { IconCheck, IconQuiz, IconLab, IconArrowRight, IconLock } from './Icons';

/**
 * An exercise step in the course path. One lesson = one step. Variants:
 *  - kind="quiz"     → mini-quiz (links to the quiz flow)
 *  - kind="practice" → practice lab (copywriting exercise)
 *
 * Locked steps are not clickable.
 */
const MODE_LABEL = { easy: 'Easy Mode', hard: 'Hard Mode', subject: 'Subject Line Mode' };

const ExerciseStep = ({ topicId, courseId, lesson, kind = 'quiz', stepNo, done, locked, active, isLast, anchorId }) => {
  const isPractice = kind === 'practice';
  const interactive = !locked && !done;

  let kicker = 'Exercise · Mini-Quiz';
  let title = '';
  let glyph = <IconQuiz size={18} />;
  let to = `/academy/${topicId}/${courseId}/${lesson.id}/quiz`;

  if (isPractice) {
    const lab = lesson.practiceLab;
    kicker = `Practice Lab · ${MODE_LABEL[lab.mode] || ''}`.trim();
    title = lab.title;
    glyph = <IconLab size={18} />;
    to = `/academy/${topicId}/${courseId}/${lesson.id}/practice`;
  } else {
    const count = lesson.quiz ? lesson.quiz.questions.length : 0;
    title = `${count} ${count === 1 ? 'question' : 'questions'}`;
  }

  const status = done ? 'done' : locked ? 'locked' : 'active';
  const node = done ? <IconCheck size={15} /> : locked ? <IconLock size={13} /> : stepNo;

  const iconClass = `ac-estep-icon ${isPractice ? 'is-practice' : ''} ${locked ? 'is-locked' : ''}`;

  const inner = (
    <>
      <span className={iconClass}>{locked ? <IconLock size={16} /> : glyph}</span>
      <div className="ac-estep-info">
        <span className="ac-step-kicker">{kicker}</span>
        <h3 className="ac-estep-title">{title}</h3>
        <span className={`ac-step-state ${done ? 'is-done' : ''} ${active ? 'is-active' : ''}`}>
          {done ? 'Completed' : locked ? 'Locked' : isPractice ? 'Write to complete' : 'Answer to complete'}
        </span>
      </div>
      {interactive && (
        <span className="ac-vstep-go">
          <IconArrowRight size={16} />
        </span>
      )}
    </>
  );

  return (
    <CourseStep status={status} icon={node} isLast={isLast} id={anchorId}>
      {interactive ? (
        <Link to={to} className={`ac-estep ${active ? 'is-active' : ''}`}>
          {inner}
        </Link>
      ) : (
        <div className={`ac-estep ${done ? 'is-done' : 'is-locked'}`}>{inner}</div>
      )}
    </CourseStep>
  );
};

export default ExerciseStep;
